import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconChart from 'cccisd-icons/chart';
import Tooltip from 'cccisd-tooltip';
import classnames from 'classnames';
import _get from 'lodash/get';
import ReportPlayer from 'js/vendor/reports/reportTemplates/result/Player';
import ItemDetails from '../ItemDetails';
import style from './style.css';

const reportList = _get(window, 'cccisd.appDefs.reports.list', []);

const SummaryReport = props => {
    const { navs, student, deploymentIds, pawnDeploymentIds } = props;
    const [selectedNavId, setSelectedNavId] = useState(navs[0].id);
    const [selectedMeasureId, setSelectedMeasureId] = useState(navs[0].measures[0].id);

    const selectedNav = navs.find(item => item.id === selectedNavId);
    const showDetails = selectedMeasureId === 'details';

    const selectedMeasure = showDetails ? null : selectedNav.measures.find(item => item.id === selectedMeasureId);
    const report = selectedMeasure ? reportList.find(item => item.id === selectedMeasure.reportHandle) : null;
    const contactType = selectedMeasure ? selectedMeasure.reporter.toLowerCase() : null;
    const pawnId = selectedMeasure ? selectedMeasure.pawnId : 0;

    const detailsPages = (() => {
        if (!showDetails) {
            return [];
        }

        return selectedNav.measures.map(measure => {
            const measureReport = reportList.find(item => item.id === measure.reportHandle);

            return {
                pawnId: measure.pawnId,
                surveyIds: measureReport.reportTemplateSettings.surveyIds,
            };
        });
    })();

    return (
        <div className={style.wrapper}>
            <div className={style.sidebar}>
                <div className={style.title}>
                    <IconChart spaceRight />
                    Assessments
                </div>
                <div className={style.assessments} data-assessment-list>
                    {navs.map(item => (
                        <a
                            key={item.id}
                            className={classnames(style.link, selectedNav.id === item.id && style.active)}
                            href=""
                            onClick={e => {
                                e.preventDefault();
                                setSelectedNavId(item.id);
                                setSelectedMeasureId(item.measures[0].id);
                            }}
                        >
                            {item.navName}
                        </a>
                    ))}
                </div>
            </div>
            <div className={style.content}>
                <div className="overflow-auto">
                    <ul className="nav nav-tabs mb-3" data-measure-list>
                        {selectedNav.measures.map(measure => (
                            <li key={measure.id} className="nav-item">
                                <a
                                    className={classnames('nav-link', measure.id === selectedMeasureId && 'active')}
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        setSelectedMeasureId(measure.id);
                                    }}
                                >
                                    {measure.reporterLabel}
                                </a>
                            </li>
                        ))}
                        <li className="nav-item">
                            <Tooltip title="See individual answers to assessment questions for all reporters. ">
                                <a
                                    className={classnames('nav-link', showDetails && 'active')}
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        setSelectedMeasureId('details');
                                    }}
                                >
                                    Item Details{selectedNav.measures.length > 1 ? ' (all)' : null}
                                </a>
                            </Tooltip>
                        </li>
                    </ul>
                </div>
                <div data-report-content>
                    {showDetails ? (
                        <ItemDetails
                            pages={detailsPages}
                            deploymentIds={deploymentIds}
                            pawnDeploymentIds={pawnDeploymentIds}
                            student={student}
                        />
                    ) : (
                        <ReportPlayer
                            key={pawnId}
                            settings={report.reportTemplateSettings}
                            student={student}
                            params={{
                                contactType,
                                pawnId,
                                deploymentIds: pawnDeploymentIds[pawnId] || [],
                                reporterName: selectedMeasure.reporterName,
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

SummaryReport.propTypes = {
    navs: PropTypes.array,
    student: PropTypes.object,
    deploymentIds: PropTypes.array,
    pawnDeploymentIds: PropTypes.object,
};

SummaryReport.defaultProps = {};

export default SummaryReport;
